import * as Yup from 'yup';
import { PqrInfo } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrInfo = {
    status: '',
    country: '',
    location: '',
    correspondenceFiling: '',
    detail: '',
};

export const validationSchema = (countryId: string) =>
    Yup.object({
        status: Yup.string().required('El estado es obligatorio'),
        country: Yup.string().required('El país es obligatorio'),
        location: Yup.string().when('country', {
            is: (value: string) => value === countryId,
            then: (schema) =>
                schema.required('La ubicación PQR es obligatoria'),
            otherwise: (schema) => schema.notRequired(),
        }),
        correspondenceFiling: Yup.string()
            .max(
                200,
                'El radicado de correspondencia debe tener 200 caracteres alfanuméricos como máximo'
            )
            .matches(
                /^[a-zA-Z0-9\s]*$/,
                'El radicado de correspondencia solo debe contener caracteres alfanuméricos'
            ),
        detail: Yup.string()
            .required('El detalle es obligatorio')
            .max(
                4294967295,
                'El detalle debe tener 4294967295 caracteres alfanuméricos como máximo'
            ),
    });
